export const moveArrayItemToTopById = (arr, id) => {
  const newArr = [...arr];
  const currentItemIndex = newArr.findIndex(item => item.id === id);
  const currentItem = newArr.splice(currentItemIndex, 1);

  return currentItem.concat(newArr);
};
